import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';

export interface DeviceFeatures {
	decommission: boolean;
	moveLicenses: boolean;
	activateEndPoints: boolean;
	transferLicenses: boolean;
}

export enum LicenseManagementDynamicConfig {
	AdpsmProductType = 'AdpsmProductType',
	Anx4ProductType = 'Anx4ProductType',
	IMXRoomProductType = 'IMXRoomProductType'
}

export enum LicenseManagementFeatureGates {
	ToggleDevicesLink = 'toggleDevicesLink'
}

export type LicenseManagementDynamicConfigType = {
	[key in LicenseManagementDynamicConfig]: {
		deviceFeatures: Partial<{
			[key in DeviceModel]: DeviceFeatures;
		}>;
	} & {
		enable: boolean;
	};
};
